import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, FormattedDate, FormattedTime, IntlShape} from 'react-intl';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import { User } from '../../common/types/types';

interface OrganisationNotificationListProps {
 intl: IntlShape;
 relay?: object;
 user: User;
}

class OrganisationNotificationList extends React.Component<OrganisationNotificationListProps> {

    typeName = 'organisationNotifications';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

    }

    render() {
        const data = this.props.user.organisation;
        let list = data.notifications;

        let columns = {
            'createdAt': {
                width: '10',
                render: (column, item) => {
                    return (<small><FormattedDate value={item.createdAt}/> <FormattedTime hour='numeric' minute='numeric' second='numeric' value={item.createdAt}/></small>);
                },
            },
            'recipients': {
                render: (column, item) => {
                    if (item[column]) {
                        return JSON.parse(item[column]).join(", ");
                    }

                    return "";
                }
            },
            'subject': {
            },
        };

        return (
            <AppPanel  breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}
            ]} className="organisationView">

                <div className="event-list-grid">
                    <PagingGrid
                            columns={columns}
                            edges={list}
                            metadata={types['organisationNotifications']}
                            pageInfo={list.pageInfo}
                            relay={this.props.relay}
                            urlMapping={urlMapping} />
                </div>

            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(OrganisationNotificationList), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        first: defaultPageSize,
        after: null,
        organisationId: '',
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                featureFlags,
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    description,
                    notifications(first: $first, after: $after) {
                        edges {
                            node {
                                id,
                                organisation_id,
                                instance_id,
                                template,
                                recipients,
                                subject,
                                createdAt,
                                author {
                                    id,
                                    realId,
                                    name,
                                    email,
                                    picture,
                                    firstname,
                                    surname,
                                },
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    },
                }
            }
        `,
    },
});
